import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useTranslation } from "react-i18next";
import Visibility from "../utils/Visibility";

export function DarkModeTogle({ showText = true }: { showText?: boolean }) {
  const { setTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 items-center cursor-pointer">
      <div className="relative w-6 h-6 flex items-center justify-center">
        <Sun
          onClick={() => setTheme("dark")}
          className="cursor-pointer text-lg font-semibold w-6 h-6 text-foreground absolute inset-0 m-auto rotate-0 scale-100 opacity-100 transition-all duration-500 ease-in-out dark:-rotate-180 dark:scale-0 dark:opacity-0"
        />
        <Moon
          onClick={() => setTheme("light")}
          className="cursor-pointer absolute inset-0 m-auto w-6 h-6 text-lg font-semibold text-foreground rotate-180 scale-0 opacity-0 transition-all duration-500 ease-in-out dark:rotate-0 dark:scale-100 dark:opacity-100"
        />
      </div>
      <Visibility visible={showText}>
        <span className="text-sm font-semibold text-foreground transition-colors duration-300">{t("gloabl.theme")}</span>
      </Visibility>
    </div>
  );
}
